import stringify from "json-stable-stringify";

export default function stableStringify(o: unknown): string {
  return stringify(o);
}
